<template>
    <div class="venue-booking-manager-container">
        <EventCreateStepMobile
            v-if="mobile"
            :booker="booker"
            :getStartedStep="getStartedStep"
            :eventId="eventId"
            :inviteEmail="inviteEmail"
            :profileSelectedDate.sync="profileSelectedDate"
            :profileEmail.sync="profileEmail"
            :mobileSteps.sync="mobileSteps"
            @steps-mobile="handleMobileSteps"
        />
        <EventListCalendar
            v-else
            :booker="booker"
            :getStartedStep="getStartedStep"
            :eventId="eventId"
            :inviteEmail="inviteEmail"
            :profileSelectedDate.sync="profileSelectedDate"
            :profileEmail.sync="profileEmail"
            @steps-mobile="handleMobileSteps"
        />
    </div>
</template>
<script>
    import useCheckScreen from '@/composables/useCheckScreen'
    import EventListCalendar from './EventListCalendar.vue'
    import EventCreateStepMobile from './EventCreateStepsMobile.vue'

    export default {
        name: 'VenueBookingManager',
        components: {
            EventListCalendar,
            EventCreateStepMobile
        },
        props: {
            booker: {
                type: Number,
                required: true
            }
        },
        setup() {
            const { isMobile, width } = useCheckScreen()
            return { isMobile, width }
        },
        data: () => ({
            mobile: false,
            mobileSteps: false,
            getStartedStep: null,
            eventId: null,
            profileSelectedDate: null,
            profileEmail: null,
            inviteEmail: ''
        }),
        watch: {
            width: {
                handler: function (width) {
                    if (width < 1000) {
                        this.mobile = true
                    } else {
                        this.mobile = false
                    }
                }
            }
        },
        methods: {
            handleMobileSteps(state) {
                this.mobileSteps = state
            }
        },
        mounted() {
            this.eventId = parseInt(localStorage.getItem('eventId'))
                ? parseInt(localStorage.getItem('eventId'))
                : null
            this.getStartedStep = parseInt(localStorage.getItem('getStartedStep'))
                ? parseInt(localStorage.getItem('getStartedStep'))
                : null
            this.inviteEmail = {
                email: localStorage.getItem('artistEmail'),
                name: localStorage.getItem('artistName')
            }
            this.profileSelectedDate = localStorage.getItem('event-date-from-profile')
            this.profileEmail = {
                email: localStorage.getItem('profile-email'),
                name: localStorage.getItem('profile-name')
            }

            localStorage.removeItem('getStartedStep')
            localStorage.removeItem('eventId')
            localStorage.removeItem('artistEmail')
            localStorage.removeItem('artistName')
            localStorage.removeItem('event-date-from-profile')
            localStorage.removeItem('profile-email')
            localStorage.removeItem('profile-name')

            if (this.isMobile) {
                this.mobile = true
            } else {
                this.mobile = false
            }
        },
        beforeDestroy() {}
    }
</script>
